import { Allocation } from '../../config';

export interface EmployeeAggregate {
  employee_name: string;
  employee_type: string | null;
  hours: number;
  total_value: number;
}

/**
 * Hours and charged value per person. Unsorted on purpose — the Overview ranks
 * by value (who has cost the job most) and Time Allocations by hours, and one
 * implementation with two callers is what keeps their totals identical.
 */
export const aggregateByEmployee = (allocations: Allocation[]): EmployeeAggregate[] => {
  const map = new Map<string, EmployeeAggregate>();
  for (const a of allocations) {
    const existing = map.get(a.employee_name);
    if (existing) {
      existing.hours += a.hours;
      existing.total_value += a.total_value;
    } else {
      map.set(a.employee_name, {
        employee_name: a.employee_name,
        employee_type: a.employee_type,
        hours: a.hours,
        total_value: a.total_value,
      });
    }
  }
  return Array.from(map.values());
};

export const initialsOf = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

